var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMiniCasas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#F0F0F0",
    rx: 11
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#363636",
    fillRule: "evenodd",
    d: "M30.748 17.344l-5.07-5.091c-.336-.337-.88-.337-1.215 0l-1.928 1.935-1.927-1.935c-.336-.337-.88-.337-1.216 0l-1.927 1.935-1.928-1.935c-.335-.337-.88-.337-1.215 0l-5.07 5.091c-.162.162-.252.381-.252.61v10.183c0 .477.385.863.86.863h20.28c.475 0 .86-.386.86-.863V17.954c0-.229-.09-.448-.252-.61zM20 14.084l4.21 4.228v8.962h-3.35v-9.32c0-.229-.091-.448-.252-.61L18.68 15.41 20 14.083zm-5.07 0l-4.211 4.228v8.962h1.661v-4.228c0-.477.385-.863.86-.863h3.38c.475 0 .86.386.86.863v4.228h1.66v-8.962l-4.21-4.229zm.83 13.19H14.1V23.91h1.662v3.365zm10.17 0h3.351v-8.962l-4.21-4.229-1.32 1.326 1.927 1.935c.161.162.252.381.252.61v9.32z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMiniCasas);
export default __webpack_public_path__ + "static/media/icon_mini_casas.fdb58e03e8f153c2ad90b876b1bfff0d.svg";
export { ForwardRef as ReactComponent };